
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://qflkyfnbpwwzcqocwpmg.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFmbGt5Zm5icHd3emNxb2N3cG1nIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzk5NjY0NjQsImV4cCI6MjA1NTU0MjQ2NH0.scb_tPgEuT2m1E4KlsvuzKsHV9H6EkHLFLqZAdyVd-E";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
